import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import { Avatar, Button, Flex, Modal, Space, Tag, Tooltip, notification } from "antd";
import { useState } from "react";
import { CouponService } from "../../services/CouponService";
import moment from "moment";
import CreateCoupon from "./CreateCoupon";
import EditMember from "./../member/EditMember";
import AddCouponCode from "./AddCouponCode";
import AddUserCoupon from "./AddUserCoupon";

export default function UserCoupon() {


    const [isModalOpenAddUserCoupon, setIsModalOpenAddUserCoupon] = useState<boolean>(false);
    const [isModalOpenAddCouponCode, setIsModalOpenAddCouponCode] = useState<boolean>(false);
    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecordUser, setEditRecordUser] = useState<object>()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<any>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Date',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return <Tooltip title={`ID: ${record?.id}`}>{moment(value).format('DD MMM YYYY HH:mm')}</Tooltip>
            },
        },
        {
            title: 'Assign To User',
            align: 'center',
            dataIndex: 'user',
            key: 'user',
            render: (user: { id: number, full_name: string }, record) => {

                console.log(user.full_name)

                return <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser({
                            id: user.id,
                            full_name: user?.full_name
                        })
                        setIsModalOpenUser(true)
                    }}>{`(${user.id}) ${user.full_name}`}</div>

            },
        },
        // {
        //     title: 'Recurring Date',
        //     align: 'center',
        //     dataIndex: 'recurring_date',
        //     key: 'recurring_date',
        //     render: (value, record) => {
        //         return value
        //     },
        // },
        {
            title: 'Coupon Name',
            align: 'center',
            dataIndex: 'coupon',
            key: 'coupon',
            render: (value, record) => {
                return <Tooltip title={`ID: ${value.id}`}>{value.name}</Tooltip>
            },
        },
        {
            title: 'Start Date',
            align: 'center',
            dataIndex: 'coupon',
            key: 'coupon',
            render: (value, record) => {
                return moment(value.start_date).isValid() ? moment(value.start_date).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'Expired Date',
            align: 'center',
            dataIndex: 'coupon',
            key: 'coupon',
            render: (value, record) => {
                return moment(value.expired_date).isValid() ? moment(value.expired_date).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'Is Redeemed',
            align: 'center',
            dataIndex: 'is_redeem',
            key: 'is_redeem',
            render: (value, record) => {
                if (!record?.couponCode?.id) {
                    return <>
                        {record?.recurring_date ? 'Reward -' : ''} No Code &nbsp;
                        <Button
                            size="small"
                            onClick={() => {
                                setEditRecord(record)
                                setIsModalOpenAddCouponCode(true)
                            }}>+</Button>
                    </>
                } else {
                    return <Tooltip title={moment(record.redeem_at).isValid() ? 'Redeem At: ' + moment(record.redeem_at).format('DD-MM-YYYY HH:mm') : null}>
                        {
                            value == 1 ?
                                <Tag color="green">แลกสำเร็จ</Tag>
                                :
                                null
                        }
                    </Tooltip>
                }

            },
        },
        {
            title: 'Is Successful',
            align: 'center',
            dataIndex: 'is_success',
            key: 'is_success',
            render: (value, record) => {
                return <Tooltip title={moment(record.success_at).isValid() ? 'Success At: ' + moment(record.success_at).format('DD-MM-YYYY HH:mm') : null}>
                    {
                        value == 1 ?
                            <Tag color="green">ใช้สำเร็จ</Tag>
                            :
                            null
                    }
                </Tooltip>
            },
        },
        // {
        //     title: '',
        //     align: 'center',
        //     dataIndex: 'created_at',
        //     key: 'created_at',
        //     render: (text, record: any) => {
        //         return (
        //             <Flex gap="small" wrap="wrap">
        //                 <div onClick={() => {
        //                     setIsModalOpen(true)
        //                     setEditRecord(record)
        //                 }} >
        //                     <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
        //                 </div>
        //                 <div onClick={() => onDelete(record.id)} >
        //                     <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
        //                 </div>
        //             </Flex>
        //         )
        //     }
        // },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await CouponService.getUserCoupons(payload)
        return res
    }

    const onDelete = async (id: number) => {
        const res = await CouponService.deleteCoupon(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateCoupon
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateCoupon>
            </Modal>

            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>

            <Modal
                title=""
                width={900}
                open={isModalOpenAddCouponCode}
                onOk={() => setIsModalOpenAddCouponCode(true)}
                onCancel={() => setIsModalOpenAddCouponCode(false)}
                footer={null}>
                <AddCouponCode
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpenAddCouponCode(false)
                        setRefreshData(p => !p)
                    }}
                ></AddCouponCode>
            </Modal>

            <Modal
                title=""
                width={900}
                open={isModalOpenAddUserCoupon}
                onOk={() => setIsModalOpenAddUserCoupon(true)}
                onCancel={() => setIsModalOpenAddUserCoupon(false)}
                footer={null}>
                <AddUserCoupon
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpenAddUserCoupon(false)
                        setRefreshData(p => !p)
                    }}
                ></AddUserCoupon>
            </Modal>

            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Add User Coupon',
                    key: 'create_user_coupon'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create_user_coupon') {
                        setEditRecord({});
                        setIsModalOpenAddUserCoupon(true)
                    }

                }}
                search
                title="Manage User Coupon"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
